/**
 * The external dependencies.
 */
import React from 'react';
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux';
import styled from 'styled-components';
import moment from 'moment';
import * as R from 'ramda';
import {assoc, compose} from 'ramda';
/**
 * The internal dependencies.
 */
import ButtonsData from '../../../assets/data/working-task-tabs';
import FlexRootWrapper from '../../../components/general/flex-root';
import Bar from '../../../components/task/working/bar';
import Header from '../../../components/task/working/header';
import Content from '../../../components/task/working/content';
import ActionBar from '../../../components/task/working/action-bar';
import HelpTab from '../../../components/task/working/help';
import HandbookTab from '../../../components/task/working/handbook';
import {
    getAllTaskWorkSteps,
    getcurrentChildren,
    getCurrentInstructions,
    getTaskErrormessageRevieved,
    getTasksCurrent,
    getTaskSteps,
    getWorkstepcount,
} from '../../../store/tasks/selectors';
import {
    setOverlay,
    tasksDeselect,
    tasksPause,
    tasksUpdate,
    tasksWorkFinished,
    tasksWorkStarted
} from '../../../store/tasks/actions';
import {taskViewSet} from '../../../store/task-view/actions';

import {getTaskViewCurrent} from '../../../store/task-view/selectors';
import {getAuthUser, getConfig} from "../../../store/auth/selectors";


const ImageWrapper = styled.div`
	width: 41%;
	min-width: 290px;
	margin-right: 20px;
	& img {
		width: 100%;
		height: auto;
	}
`;

const ContentWrapper = styled(FlexRootWrapper)`
	position: relative;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
	border: 8px solid #43abf3;
	background-color: #f5f5f5;
`;

const MainContentWrapper = styled(FlexRootWrapper)`
	padding: 0 35px 0 42px;
`;

class Base extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            materials: "",
            image: "",
            numPages: null,
            pageNumber: 1,
        };
        const {tasksWorkStarted, task} = this.props;
        tasksWorkStarted(task);
    }

    buttonAction = (item) => assoc('action', () => this.props.taskViewSet(item.id))(item);

    onDocumentLoadSuccess = ({numPages}) => {
        this.setState({numPages});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {tasksWorkStarted, task} = this.props;
        tasksWorkStarted(task);
    }

    completeTask = () => {
        const {
            task,
            tasksUpdate,
            tasksDeselect,
            tasksWorkFinished,
            history,
            setOverlay,
            workstepcount
        } = this.props;

        if (task.status !== 'failed') {
            if (task.step === workstepcount) {
                tasksUpdate(task.id, {status: 'done'});
            } else {
                tasksUpdate(task.id, {status: '', worker: ''});
            }
        }

        tasksDeselect();
        tasksWorkFinished();
        setOverlay({task: task, type: 'completeTask', workstepcount: workstepcount});

        history.push('/dashboard/shop');
    };

    pause = () => {
        const {
            task,
            tasksPause,
            tasksDeselect,
            tasksWorkFinished,
        } = this.props;

        if (task.status !== 'failed') {
            tasksPause(task.id, {status: 'reserved'});
        }
        tasksDeselect();
        tasksWorkFinished();
    }

    /*async componentDidMount() {

        const {tasksWorkStarted, task, acceptedErrormessage} = this.props;
        await callRoute(['getTasksSteps', {
            client: this.props.task.order_client,
            erpnumber: this.props.task.erpnumber
        }]).then((response) => {
            if (response.data._embedded) {
                let newData = {
                    materials: response.data._embedded.instruction[0].content,
                    image: TaskImage
                };
                newData.image = response.data._embedded.instruction[0]._links.resourcesEntity.href;
                this.setState(newData);
            }

        });
    }*/

    setworkgroup = () => {
        const {user, tasksUpdate, task} = this.props;
        tasksUpdate(task.id, {workgroup: user.id});

    };

    render() {
        const {
            task,
            steps,
            workSteps,
            currentTaskView,
            workstepcount,
            children,
            config,
            allWorkSteps,
            instructions,
            user,
        } = this.props;
        const {pageNumber, numPages} = this.state;
        let name = '';
        if (R.find(R.propEq('selectionorder', task.step))(workSteps) !== undefined) {
            name = R.find(R.propEq('selectionorder', task.step))(workSteps).name;
        }
        let materials = this.state.materials;
        // console.log("instructions", instructions)
        task.image = this.state.image;


        let workgroup = task.userId !== user.id && !R.isEmpty(task.userId) && !R.isNil(task.userId);

        const buttons = ButtonsData.map(this.buttonAction);

        return (
            <FlexRootWrapper>
                <Bar task={task} longNumber={task.erpnumber} client={task.order_client} workgroupview={workgroup}/>
                <ContentWrapper>
                    <MainContentWrapper>
                        <Header
                            task={task}
                            quantity={task.quantity}
                            shortNumber={task.erpnumberSmall}
                            workplace={task.place}
                            due={moment(task.order_deadline).format('DD.MM.YY')}
                            step={task.step}
                            maxSteps={workstepcount}
                            config={config}
                        />

                        <Content
                            image={task.image}
                            stepNumber={task.step}
                            step={name}
                            materials={materials}
                            children={children}
                            instructions={instructions}
                            description={task.description}
                        />
                    </MainContentWrapper>

                    <ActionBar
                        buttons={buttons}
                        currentView={currentTaskView}
                        complete={this.completeTask}
                        pause={this.pause}
                        workgroupview={workgroup}
                        setworkgroup={this.setworkgroup}
                    />

                    {currentTaskView && currentTaskView === 'help' && (
                        <HelpTab close={() => this.props.taskViewSet('')}/>
                    )}

                    {currentTaskView && currentTaskView === 'guide' && (
                        <HandbookTab close={() => this.props.taskViewSet('')}/>
                    )}
                </ContentWrapper>
            </FlexRootWrapper>
        );
    }
}

export default compose(
    connect(
        (state) => ({
            workSteps: getTaskSteps(state),
            task: getTasksCurrent(state),
            currentTaskView: getTaskViewCurrent(state),
            acceptedErrormessage: getTaskErrormessageRevieved(state),
            workstepcount: getWorkstepcount(state),
            children: getcurrentChildren(state),
            config: getConfig(state),
            allWorkSteps: getAllTaskWorkSteps(state),
            instructions: getCurrentInstructions(state),
            user: getAuthUser(state),
        }), {
            taskViewSet,
            tasksUpdate,
            tasksPause,
            tasksDeselect,
            setOverlay,
            tasksWorkStarted,
            tasksWorkFinished,
        }
    ),
    withRouter
)(Base);



// WEBPACK FOOTER //
// ./src/containers/task/working/base.js